export const messages: Record<string, string> = {
  // Navigation
  'nav.news': 'News',
  'nav.team': 'Team',

  // Common
  'common.save': 'Save',
  'common.saving': 'Saving...',
  'common.cancel': 'Cancel',
  'common.back': 'Back',
  'common.edit': 'Edit',
  'common.delete': 'Delete',
  'common.loading': 'Loading...',
  'common.publish': 'Publish',
  'common.publishing': 'Saving…',

  // News
  'news.title': 'Articles',
  'news.new': 'New Article',
  'news.create': 'Write Article',
  'news.edit': 'Edit Article',
  'news.empty': 'No articles yet.',
  'news.loadError': 'Error loading articles',
  'news.saveSuccess': 'Article saved successfully.',
  'news.saveError': 'Error saving: {message}',
  'news.publishError': 'Error publishing: {message}',
  'news.category': 'Category',
  'news.categoryPlaceholder': 'Select a category',
  'news.titleLabel': 'Title',
  'news.titlePlaceholder': 'Title of your article',
  'news.titleInput': 'Enter title*',
  'news.shortDescription': 'Short Description',
  'news.shortDescriptionLabel': 'Short description*',
  'news.shortDescriptionPlaceholder':
    'Briefly summarize what your article is about.',
  'news.category.news': 'News',
  'news.category.events': 'Events',
  'news.category.updates': 'Updates',

  // Team
  'team.title': 'Team Members',
  'team.new': 'New Member',
  'team.create': 'Add Team Member',
  'team.edit': 'Edit Team Member',
  'team.empty': 'No team members yet.',
  'team.loadError': 'Error loading team members',
  'team.saveSuccess': 'Team member saved successfully.',
  'team.updateSuccess': 'Changes saved.',
  'team.saveError': 'Error saving: {message}',
  'team.name': 'Name',
  'team.namePlaceholder': 'Enter name',
  'team.group': 'Team',
  'team.groupPlaceholder': 'Select job group',
  'team.level': 'Experience Level',
  'team.levelPlaceholder': 'Select level',
  'team.role': 'Role',
  'team.rolePlaceholder': 'Select job',
  'team.expirationDate': 'Expiration Date',
  'team.expirationDatePlaceholder': 'Select date',
  'team.expirationLabel': 'until {date}',
};
